import(/* webpackMode: "eager" */ "/codebuild/output/src2910923476/src/top-ten/src/app/error.jsx");
